export const normalizeToArray = (...args) => [].concat(...args);
